module.exports = __webpack_public_path__ + "img/avatar.42f09d75.png";